import { useApiUrl } from '../../../../global/config/useApiUrl';
import { useCampfireFetch } from '../../../../global/network/useCampfireFetch';

interface SendCalendarInviteParams {
  attendeeEmail: string;
  title: string;
  description: string;
  startDateTime: string;
  endDateTime: string;
  location?: string | null;
  meetingLink?: string | null;
  phoneNumber?: string | null;
}

export const useSendCalendarInvite = () => {
  const apiUrl = useApiUrl();
  const { run, isLoading, error } = useCampfireFetch<{ success: boolean }>({
    defer: true,
  });

  const send = async (params: SendCalendarInviteParams) => {
    return run({
      url: `${apiUrl}/vm/comms/send-calendar-invite`,
      method: 'POST',
      data: params,
    });
  };

  return {
    send,
    isLoading,
    error,
  };
};
